import React from "react";

const WorkoutDesc = ({ setshowModal, workout }) => {
  return (
    <div className="alert-modal">
      <div className="alert-modal-box ">
        <div className="alert-modal-container">
          <div className="d-flex justify-content-end ">
            <i className="fa fa-times" onClick={() => setshowModal(false)}></i>
          </div>
          <header className="alert-modal-heading">{workout?.name}</header>
          <body className="d-flex flex-column justify-content-between align-item-center alert-modal-body gap-1 px-3">
            <div
              className="copy-label text-start my-2"
              dangerouslySetInnerHTML={{
                __html: workout?.desc
                  ? workout?.desc
                      .replace(/\n/g, "<br />")
                      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                  : "You will see description here once added",
              }}
            ></div>
          </body>
        </div>
      </div>
    </div>
  );
};

export default WorkoutDesc;
